/**
 * The kinds of record the global search (`GET /search?q=`) answers.
 *
 * Each value is the `type` of one provider in the backend's
 * `search/providers.ts` and of one icon in the frontend's
 * `components/command/searchTypes.tsx`. Adding a kind is all three: a member
 * here, a provider that reuses its list's own access rule, and an icon.
 */
export var SearchResultType;
(function (SearchResultType) {
    SearchResultType["Event"] = "event";
    SearchResultType["Vendor"] = "vendor";
    SearchResultType["Venue"] = "venue";
    SearchResultType["Guest"] = "guest";
    SearchResultType["Task"] = "task";
    SearchResultType["File"] = "file";
    SearchResultType["Conversation"] = "conversation";
})(SearchResultType || (SearchResultType = {}));
/** The heading each kind's group of results is shown under. */
export const SEARCH_RESULT_LABELS = {
    [SearchResultType.Event]: 'Events',
    [SearchResultType.Vendor]: 'Vendors',
    [SearchResultType.Venue]: 'Venues',
    [SearchResultType.Guest]: 'Guests',
    [SearchResultType.Task]: 'Tasks',
    [SearchResultType.File]: 'Files',
    [SearchResultType.Conversation]: 'Conversations',
};
/** Whether a string names a kind the search knows. */
export function isSearchResultType(value) {
    return Object.values(SearchResultType).includes(value);
}
//# sourceMappingURL=search.js.map